import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import HolidaysAndBreaksForm from "./HolidaysAndBreaksForm";

const CallHolidaysAndBreaks = ({ match }) => {

    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <HolidaysAndBreaksForm id={match.params.id} context={"new"} />
        </div>
    );
}

export default CallHolidaysAndBreaks;